import CustomPortal from "../../CustomPortal"
import RegisterSuccess from "../../registration-component/RegisterSuccess"

const RegisterSuccessForm = () => {
    return (
        <CustomPortal
            header="Sign up successfully"
            Component={RegisterSuccess}
            showStatus={true}
        />
    )
}

export default RegisterSuccessForm